import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import useGetThreads from "#/components/messaging/hooks/useGetThreads"

export function UnreadMessagesDot(): JSX.Element | null {
  const { data: messageThreads } = useGetThreads()
  const hasUnread = messageThreads?.threads?.some((thread) => thread.hasUnreadMessages)

  if (!hasUnread) {
    return null
  }

  return (
    <Box display="flex" justifyContent="flex-end">
      <Box
        bgcolor={(theme) => theme.palette.primary.main}
        borderRadius={(theme) => theme.tokens.borderRadius.round}
        height="7px"
        width="7px"
      />
    </Box>
  )
}
